import * as patches from './patches'

export default (name, component) => {
  const patch = patches[name]

  if (patch) {
    patch.call(null, component)
  }
}
